<!--
 * @Description: 
 * @Author: xgx
 * @Date: 2022-10-13 09:57:02
 * @LastEditors: xgx
 * @LastEditTime: 2023-09-07 09:29:06
-->
<template>
  <div class="box">
    <div style="display: flex;width:100%">
      <div class="left">
        <div style="font-weight:600;" class="title">问答库分类</div>
        <div class="search">
          <a-input-search
            v-model:value="value"
            placeholder="搜索分类"
            size="large"
            @search="onSearch"
          >
            <template #enterButton>
              <img class="img" src="@/assets/images/search.jpg" />
            </template>
          </a-input-search>
        </div>

        <div :style="{height:heightTwo}" class="tree-box">
          <div
            @click="selectItem(item)"
            :class="item.id == selectGroupItem.id ? 'select-item' : ''"
            class="one"
            v-for="(item, index) in grouplist"
          >
            <div style="display: flex">
              <div :class="item.id == selectGroupItem.id ? 'title-icon' : ''">
                <span class="icon-link-m"></span>
              </div>
              <div
                :style="{
                  color: item.id == selectGroupItem.id ? '#409EFF' : '',
                }"
                class="title-name"
              >
                <span :title="item.classificationName">{{ item.classificationName }}</span>
              </div>
            </div>
            <div>
              <a-popover placement="bottomRight">
                <template slot="content">
                  <a v-if="codeData.indexOf('264') != -1" @click="enitItem(item)" style="cursor: pointer"
                    >编辑分类</a
                  >
                  <div
                    v-if="codeData.indexOf('263') != -1"
                    @click="delGroupOpen(item)"
                    style="
                      color: rgba(245, 108, 108, 1);
                      margin-top: 10px;
                      cursor: pointer;
                    "
                  >
                    删除分类
                  </div>
                </template>
                <i class="el-icon-more fixed-inner"></i>
              </a-popover>
            </div>
          </div>
        </div>
        <div v-if="codeData.indexOf('247') != -1" @click="addAdminFn" class="add-group">
          <span>+ </span><span>添加分类</span>
          <div class="add-dir"></div>
        </div>
      </div>
      <div class="middle"></div>
      <div class="right">
        <div style="font-weight: 600;" class="right-name">问答清单-{{ selectGroupItem && selectGroupItem.classificationName }}</div>
        <div class="top">
          <div style="display: flex">
            <el-button class="bei-jin" style="margin-right:10px" v-if="codeData.indexOf('58') != -1" @click="addLian" type="primary"
              >新增问答</el-button
            >
            <div v-if="codeData.indexOf('60') != -1" @click="batchDeletion" class="batch-operation">
                <el-button type="primary" plain>批量删除</el-button>
            </div>
          </div>
          <div class="search">
            <a-input-group compact>
              <a-select
                v-model:value="selectName"
                style="width: 100px; background: #ccc"
              >
                <a-select-option
                  @click="selectFn(item.value)"
                  :key="index"
                  v-for="(item, index) in selectArr"
                >
                  {{ item.label }}
                </a-select-option>
              </a-select>
              <a-input
                v-model:value="value"
                placeholder="请输入搜索内容"
                style="width: 173px"
              />
            </a-input-group>
            <el-button class="bei-jin" @click="search" type="primary">查询</el-button>
          </div>
        </div>
        <coententTable
          :y="height"
          @handleSizeChange="handleSizeChange"
          @onShowSizeChange="onShowSizeChange"
          :columns="type == 1 ? columns : columnsTwo"
          :dataSource="dataSource"
          :pagination="pagination"
          :customSlot="customSlot"
          @selectedRowKeys="selectedRowKeys"
          :isSelectRow="true"
          :rowKeys="rowKeys"
          :loading="loading"
        >
          <template v-slot:operation="scopeVal">
             <div style="display: flex">
                 <div class="btnTwo" style="margin-right: 14px" v-if="codeData.indexOf('62') != -1" @click="permissionManagement(scopeVal.scope)">编辑</div>
                <div
                  v-if="codeData.indexOf('63') != -1"
                  @click="open(scopeVal.scope)"
                  class="btnThree"
                  >删除</div
                >
             </div>
          </template>
        </coententTable>
      </div>
    </div>
    <el-dialog
      title="确认删除问答?"
      :visible.sync="deleteVariableShow"
      width="450px"
      custom-class="tips-box"
      top="17%"
    >
      <span>请确认是否继续删除操作。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteVariableShow = false">取消</el-button>
        <el-button :loading="deleteShowTwo" type="danger" @click="deleteVariable">确认删除</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="确认删除问答?"
      :visible.sync="deleteVariableShowTwo"
      width="450px"
      custom-class="tips-box"
      top="17%"
    >
      <span>请确认是否继续删除操作。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteVariableShowTwo = false">取消</el-button>
        <el-button :loading="deleteShow" type="danger" @click="batch">确认删除</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="确认删除问答分类?"
      :visible.sync="deleteGroupShow"
      width="450px"
      custom-class="tips-box"
      top="17%"
    >
      <span>请确认是否继续删除操作。</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="deleteGroupShow = false">取消</el-button>
        <el-button :loading="delGroupShow" type="danger" @click="delGroup">确认删除</el-button>
      </span>
    </el-dialog>
    <el-dialog
      :title="ruleForm.id?'编辑问答库分类':'添加问答库分类'"
      :visible.sync="answersShow"
      width="535px"
      class="column-box"
      top="12%"
    >
      <div class="colum-title-box">
        <i style="margin-right: 8px" class="el-icon-info"></i
        >合理分类以便于日常运营中的问题管理
      </div>
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="分类名称" prop="classificationName">
          <el-input
            v-model="ruleForm.classificationName"
            placeholder="请输入分类名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="ruleForm.sort" placeholder="请输入排序"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="answersShow = false">取 消</el-button>
        <el-button :loading="submintShow" size="medium" type="primary"  @click="tihuan">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import coententTable from "@/components/coentent_table.vue";
import {
  list,
  del,
  listLinks,
  delLink,
  delBatch,
  saveQuestionClassification,
  updateQuestionClassification,
  deleteQuestionClassification,
  deleteQuestionAnswerIds
} from "./custom_variables";
import { message } from "ant-design-vue";
export default {
  data() {
    var idNumber = (rule, value, callback) => {
      var regex = /^[0-9]*[1-9][0-9]*$/;
      if (!regex.test(this.ruleForm.sort)) {
          callback(new Error("只能输入非0正整数"));
        } else {
          callback();
        }
    };
    return {
      value: "",
      type: 1,
      deleteShow:false,
      deleteShowTwo:false,
      delGroupShow:false,
      height: 0,
      heightTwo:0,
      isCloseAll: false,
      deleteVariableShowTwo:false,
      deleteGroupShow: false,
      submintShow:false,
      expandedKeys: [],
      selectedKeys: [],
      treeData: [],
      organization: "1",
      role: undefined,
      answersShow: false,
      value: "",
      columns: [
        {
          title: "问题描述",
          dataIndex: "questionDescription",
          ellipsis:true,
          customCell: column => {
                        return {
                        style: {
                            'min-width': "320px",
                            'max-width': "660px",
                        }
                    };
                    },
                    customHeaderCell: column => {
                    return {
                        style: {
                            'min-width': "320px",
                            'max-width': "660px",
                        }
                    };
                    }
        },
        {
          title: "关键词",
          dataIndex: "keyWords",
           width: 120,
          ellipsis:true,
        },
        {
          title: "命中次数",
          dataIndex: "hitFrequency",
          width: 120,
          ellipsis:true,
        },
        {
          title: "满意度",
          dataIndex: "satisfaction",
          width: 120,
          ellipsis:true,
        },
        {
          title: "操作",
          dataIndex: "operate",
          scopedSlots: { customRender: "action" },
          fixed: "right",
          width: 174,
        },
      ],
      customSlot: [
        {
          name: "name",
          customRender: "name",
        },
        {
          name: "sort",
          customRender: "sort",
        },
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
        pageSizeOptions: ["10", "20", "30"],
      },
      dataSource: [],
      visible: false,
      grouplist: [],
      item: {},
      leftLoading: false,
      dialogVisible: false,
      ruleForm: {},
      rules: {
        classificationName: [
          { required: true, message: "请输入分类名称", trigger: "blur" },
        ],
        sort: [
          { required: true, message: "请输入排序", trigger: "blur" },
          {
            validator: idNumber,
          },
        ],
      },
      selectGroupItem: '',
      searchVariableName: "",
      deleteVariableShow: false,
      linkItem: {},
      groupItem: {},
      rowKeys: [],
      selectName: "问题描述",
      selectValue: "1",
      loading:false,
      selectArr: [
        {
          label: "问题描述",
          value: "1",
        },
        {
          label: "关键词",
          value: "2",
        },
      ],
      codeData:[],
    };
  },
  components: {
    coententTable,
  },
  mounted() {
    this.getList();
    this.selectGroupItem = JSON.parse(sessionStorage.getItem('selectGroupItem'));
    this.heightTwo = document.documentElement.clientHeight - 290 + 'px';
    this.codeData = JSON.parse(sessionStorage.getItem('menuData'))
  },
  methods: {
    handleMenuClick(){

    },
    batchDeletion(){
        if(this.rowKeys.length == 0){
            message.error('请选择操作项');
            return;
        }
        this.deleteVariableShowTwo = true;
    },
    batch(){
        this.deleteShow = true;
        deleteQuestionAnswerIds({
          siteId:sessionStorage.getItem('siteId'),
          ids:this.rowKeys,
        }).then((res)=>{
            if(res.code == 0){
                 this.getVariableList();
                 this.deleteVariableShowTwo = false;
                  this.deleteShow = false;
                 this.rowKeys = [];
            }
        })
    },
    tihuan() {
      this.submintShow = true;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if(this.ruleForm.id){
            updateQuestionClassification({
            siteId: sessionStorage.getItem("siteId"),
            ...this.ruleForm,
          }).then((res) => {
            if (res.code == 0) {
              this.getList();
              this.answersShow = false;
            }
            this.submintShow = false;
          });
          }else{
            saveQuestionClassification({
            siteId: sessionStorage.getItem("siteId"),
            ...this.ruleForm,
          }).then((res) => {
            if (res.code == 0) {
              this.getList();
              this.answersShow = false;
            }
            this.submintShow = false;
          });
          }
        }
      });
    },
    changeDisplayStatus() {},
    handleClose() {
      console.log("asdas");
      this.dialogVisible = false;
    },
    selectedRowKeys(keys) {
      this.rowKeys = keys;
    },
    deleteVariable() {
      this.deleteShowTwo = true;
      delLink({
        id: this.linkItem.id,
        siteId:sessionStorage.getItem('siteId')
      }).then((res) => {
        if (res.code == 0) {
          this.deleteVariableShow = false;
          this.deleteShowTwo = false;
          this.getVariableList();
        }
      });
    },
    open(item) {
      this.deleteVariableShow = true;
      this.linkItem = item;
    },
    permissionManagement(item) {
      this.$router.push({
        path: "/index/interaction/knowledge_base/add",
        query: {
          title: "新增问答",
          islast: true,
          id: item.id,
        },
      });
    },
    batchDel() {
      if (this.rowKeys.length == 0) {
        message.error("请选择操作项");
        return;
      }
      delBatch({
        ids: this.rowKeys,
        groupId: this.selectGroupItem.id,
      }).then((res) => {
        if (res.code == 0) {
          this.getVariableList();
        }
      });
    },
    search() {
      this.pagination.current = 1;
      this.getVariableList();
    },
    //获取列表
    getVariableList() {
      const _this = this;
      this.loading = true;
      let reqData = {
        current: _this.pagination.current,
        isQuestionClassificationId: _this.selectGroupItem.id || "",
        siteId: sessionStorage.getItem("siteId"),
        size: _this.pagination.pageSize,
      };
      if (this.selectValue == 2) {
        reqData.keyWords = this.value;
      }
      if (this.selectValue == 1) {
        reqData.questionDescription = this.value;
      }
      listLinks(reqData).then((res) => {
        if (res.code == 0) {
          _this.dataSource = res.data.records;
          _this.pagination.total = res.data.total;
          _this.pagination.current = res.data.current;
          _this.height = 0;
          if(_this.pagination.total > 0){
              _this.height = document.documentElement.clientHeight - 500;
              _this.heightTwo = document.documentElement.clientHeight - 290 + 'px';
              window.onresize = () => {
                return (() => {
                  _this.height = document.documentElement.clientHeight - 500;
                  _this.heightTwo = document.documentElement.clientHeight - 290 + 'px';
                })();
              };
          }
          if (_this.pagination.current != 1 && _this.dataSource.length == 0) {
            _this.pagination.current--;
            _this.getVariableList();
          }
        }
         this.loading = false;
      });
    },

    addLian() {
      if (!this.selectGroupItem) {
        message.error("请选择分类,如没有请先创建");
      } else {
        this.$router.push({
          path: "/index/interaction/knowledge_base/add",
          query: {
            title: "新增问答",
            islast: true,
            id: "",
          },
        });
      }
    },
    selectItem(item) {
      this.selectGroupItem = item;
      sessionStorage.setItem('selectGroupItem',JSON.stringify(item))
      this.getVariableList();
    },
    delGroupOpen(item) {
      this.groupItem = item;
      this.deleteGroupShow = true;
    },
    delGroup() {
      this.delGroupShow = true;
      deleteQuestionClassification({
        id: this.groupItem.id,
        siteId:sessionStorage.getItem('siteId')
      }).then((res) => {
        if (res.code == 0) {
          this.deleteGroupShow = false;
          this.delGroupShow = false;
          this.getList();
          this.getVariableList();
        }
      });
    },
    enitItem(item) {
      this.ruleForm = item;
      this.answersShow = true;
      if(this.$refs.ruleForm){
                this.$refs.ruleForm.resetFields();
            }
    },
    addAdminFn() {
      this.answersShow = true;
      this.ruleForm = {};
      if(this.$refs.ruleForm){
                this.$refs.ruleForm.resetFields();
            }
    },
    onSearch() {
      this.getList();
    },
    // 切换 搜索
    onShowSizeChange(current) {
      this.pagination.current = current;
      this.getVariableList();
    },
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.current = 1;
      this.getVariableList();
    },
    getList() {
      this.leftLoading = true;
      list({
        siteId: sessionStorage.getItem("siteId"),
        groupName: this.value,
      }).then((res) => {
        this.grouplist = res.data;
        if (res.data.length == 0) {
          this.grouplist = [];
        } else {
          if(!this.selectGroupItem){
            this.selectGroupItem = res.data[0];
          }
          this.getVariableList();
        }
        this.leftLoading = false;
      });
    },
    selectFn(value) {
      this.selectValue = value;
    },
  },
};
</script>

<style lang="less" scoped>
.box {
     display: flex;
    width: 100%;
    height: calc(90% - 17px);
  .left {
    width: 250px;
    //height: calc(113% - 7px);
    font-size: 14px;
    color: #000;
    padding: 24px;
    //position: relative;
    .title {
      margin-bottom: 24px;
    }
    .search {
      margin-bottom: 12px;
    }
    /deep/ .ant-btn-primary {
      background: #1890ff;
      padding: 0 5px;
    }
    /deep/ input::-webkit-input-placeholder {
      color: #415058;
    }
    /deep/ .ant-input {
      background: #f7f7f7;
    }
  }
  .right {
    flex: 1;
    /* height: 100%; */
    font-size: 14px;
    padding-top: 24px;
    width: 500px;
    .right-name {
      padding-left: 24px;
      color: #000;
    }
    .log-box {
      //border-bottom: solid 1px #dcdfe6;
      display: flex;
      margin-left: 24px;
      margin-right: 24px;
      margin-top: 24px;
      .log {
        padding: 10px 20px;
        border-top: solid 1px #dcdfe6;
        border-left: solid 1px #dcdfe6;
        cursor: pointer;
        border-bottom: solid 1px #dcdfe6;
      }
      .log:last-child {
        border-right: solid 1px #dcdfe6;
        border-top-right-radius: 10px;
      }
      .log:first-child {
        border-top-left-radius: 10px;
      }
    }
     .search {
            display: flex;
            width: 350px;
            /deep/ .ant-select-selection {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .ant-input {
                background-color: rgba(245, 247, 250, 1);
                height: 40px;
            }
            /deep/ .el-select .el-input__inner {
                background-color: rgba(245, 247, 250, 1);
            }
            /deep/ input::-webkit-input-placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__placeholder {
                color: rgba(102, 111, 128, 1);
            }
            /deep/ .ant-select-selection__rendered {
                line-height: 39px;
            }
            /deep/ input::-webkit-input-placeholder {
            color: #415058;
            }
            /deep/ .ant-select-selection__placeholder {
                color: #415058;
            }
        }
    /deep/ .pagination {
      //bottom: -120px !important;
    }
  }
}
.top {
  padding: 24px;
  padding-bottom: 0px;
  display: flex;
  justify-content: space-between;
  .search {
    display: flex;
    width: 353px;
  }

  .add-img {
    margin-top: -2px;
    margin-right: 3px;
  }
}
/deep/ .ant-tree {
  max-height: 630px;
  overflow: hidden;
  overflow-y: auto;
}
.dir {
  height: 1px;
  background: #dcdfe6;
  margin-left: 330px;
  margin-right: 24px;
  margin-top: -1px;
}
.middle {
    height: calc(112% + 12px);
    width: 1px;
    background: #f4f4f6;
}
.tr-one {
  display: flex;
}
.quan {
  width: 24px;
  height: 24px;
  background: #fff;
  border: solid 1px #ccc;
  border-radius: 50%;
}
.close-name {
  color: #303133;
  font-weight: 400;
  margin-top: 4px;
}
.close-img {
  margin-top: -1px;
  margin-right: 4px;
  cursor: pointer;
}
.sort {
  display: flex;
  border: solid 1px #dcdfe6;
  width: 90px;
  border-radius: 5px;
}
.sort-box {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
  border-right: solid 1px #dcdfe6;
}
.sort-box-two {
  width: 30px;
  height: 30px;
  background: #f5f7fa;
  text-align: center;
  line-height: 30px;
  border-top-right-radius: 5px;
  border-bottom-right-radius: 5px;
  border-left: solid 1px #dcdfe6;
}
.sort-style {
  width: 30px;
  border: none;
  outline: none;
  text-align: center;
}
.one {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px;
  cursor: pointer;
  border-radius: 4px;
}
.fixed-inner {
  transform: rotate(90deg);
  cursor: pointer;
}
.title-name {
  color: rgba(48, 49, 51, 1);
  font-size: 14px;
  text-align: left;
  font-family: Roboto-regular;
  font-weight: 500;
  margin-left: 10px;
   overflow:hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow:ellipsis;
  max-width: 100px;
}
.add-group {
  height: 36px;
  line-height: 36px;
  border-radius: 4px;
  background-color: rgba(64, 158, 255, 1);
  text-align: center;
  color: #fff;
  font-weight: 500;
  width: 200px;
  position: absolute;
  bottom: 10px;
  cursor: pointer;
  z-index: 2;
}
.tree-box {
  //display: flex;
  align-content: space-between;
  overflow-y: auto;
  scrollbar-width: none; /* firefox */
  -ms-overflow-style: none; /* IE 10+ */
  overflow-x: hidden;
  overflow-y: auto;
  ::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}
  
}
.tree-box::-webkit-scrollbar {
  display: none; /* Chrome Safari */
}

/deep/ .pagination {
  left: 0;
}
.fixed-inner:hover {
}
.eidt-ground {
}
/deep/ .el-dialog__body {
  padding-bottom: 0px;
}
.select-item {
  background-color: rgba(236, 245, 255, 1);
}
.title-icon {
  .icon-link-m:before {
    color: rgba(64, 158, 255, 1);
  }
}
.add-dir {
  position: absolute;
  top: -14px;
  height: 10px;
  background: #fff;
  width: 249px;
  z-index: 2;
  left: -23px;
}
.batch-operation {
  /deep/ .ant-btn,
  .ant-dropdown-trigger {
    height: 35px;
    background: #ecf5ff;
    color: #18abff;
    border-color: #c9e3ff;
    text-align: center;
  }
}
/deep/.ant-switch-checked {
  background-color: #39d362;
}
.colum-title-box {
  height: 34px;
  line-height: 34px;
  border-radius: 4px;
  background-color: rgba(244, 244, 245, 1);
  padding-left: 12px;
  color: rgba(144, 147, 153, 1);
  margin-bottom: 24px;
}
/deep/ .el-dialog__title {
  font-weight: 600;
}
/deep/ .el-dialog__close {
  font-weight: 600;
  color: #000;
}
/deep/ .el-form-item__label {
  text-align: left;
  width: 81px !important;
}
/deep/ .el-form-item__content {
  margin-left: 85px !important;
}
::v-deep .el-dialog{
       display: flex;
       flex-direction: column;
       margin:0 !important;
       position:absolute;
       top:50%;
       left:50%;
       transform:translate(-50%,-50%);
       max-height:calc(100% - 30px);
       max-width:calc(100% - 30px);
   }
  ::v-deep  .el-dialog .el-dialog__body{
       flex:1;
       overflow: auto;
   }
   /deep/ .ant-spin-nested-loading{
      width: 100%;
   }
   .bei-jin{
       background: #176de6;
   }
   .btnTwo {
  border-radius: 3px;
  background-color: rgba(240, 246, 255, 1);
  color: rgba(23, 109, 230, 1);
  font-size: 12px;
  font-family: Roboto;
  border: 1px solid rgba(23, 109, 230, 1);
  width: 56px;
  height: 28px;
  line-height: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.btnThree {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(255, 242, 242, 1);
  color: rgba(245, 108, 108, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(245, 108, 108, 1);
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.btnFour {
  width: 56px;
  height: 28px;
  line-height: 16px;
  border-radius: 3px;
  background-color: rgba(244, 244, 245, 1);
  color: rgba(144, 147, 153, 1);
  font-size: 12px;
  text-align: center;
  font-family: Roboto;
  border: 1px solid rgba(211, 212, 214, 1);
  display: flex;
  justify-content: center;
  align-items: center;
}

.column-box{
  .el-button--primary {
  background: #176de6;
}
}
</style>
